import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { externalLinks } from '../data/mock';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Handle language toggle and close menu
  const handleLanguageToggle = () => {
    toggleLanguage();
    setMobileMenuOpen(false); // Close menu after language switch
  };

  // Check if KakaoTalk URL exists
  const hasKakao = externalLinks.kakao && externalLinks.kakao.length > 0;
  const naverPlaceLabel = language === 'ko' ? '네이버 플레이스' : 'Naver Place';

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-black border-b border-white/25">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="#" className="text-white text-lg md:text-xl font-bold">
            강남놀이터 코엑스점
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6">
            <a 
              href={externalLinks.naverStore}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white text-sm transition-colors"
            >
              {t('reserve')}
            </a>
            {hasKakao && (
              <a 
                href={externalLinks.kakao}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white text-sm transition-colors"
              >
                {t('inquiry')}
              </a>
            )}
            <a 
              href={externalLinks.naverPlace}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white text-sm transition-colors"
            >
              {naverPlaceLabel}
            </a>
            <a 
              href={externalLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white text-sm transition-colors"
            >
              {t('instagram')}
            </a>
            <a 
              href={externalLinks.phone}
              className="text-white/60 hover:text-white text-sm transition-colors flex items-center gap-1"
            >
              <Phone size={14} />
              {t('call')}
            </a>
            
            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="px-3 py-1 border border-white/40 text-white/80 hover:text-white hover:border-white text-sm transition-all"
              style={{ borderRadius: 0 }}
            >
              {language === 'ko' ? 'EN' : 'KR'}
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-black/95 border-t border-white/10">
          <div className="px-4 py-4 space-y-3">
            <a 
              href={externalLinks.naverStore}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white/80 hover:text-white py-2 text-base"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('reserve')}
            </a>
            {hasKakao && (
              <a 
                href={externalLinks.kakao}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-white/80 hover:text-white py-2 text-base"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('inquiry')}
              </a>
            )}
            <a 
              href={externalLinks.naverPlace}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white/80 hover:text-white py-2 text-base"
              onClick={() => setMobileMenuOpen(false)}
            >
              {naverPlaceLabel}
            </a>
            <a 
              href={externalLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white/80 hover:text-white py-2 text-base"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('instagram')}
            </a>
            <a 
              href={externalLinks.phone}
              className="block text-white/80 hover:text-white py-2 text-base"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('call')}
            </a>
            <button
              onClick={handleLanguageToggle}
              className="w-full mt-2 px-4 py-2 border border-white/40 text-white/80 hover:text-white hover:border-white text-base transition-all"
              style={{ borderRadius: 0 }}
            >
              {language === 'ko' ? 'Switch to English' : '한국어로 변경'}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
